document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.swiper-announcement', {
    spaceBetween: 0,
    speed: 400,
    effect: "fade",
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});
